<script>
import Mark from 'mark.js'

export default {
  name: 'FlotoMarkedContent',
  props: {
    text: { type: String, default: '' },
  },
  watch: {
    text() {
      this.$nextTick(() => {
        this.markText()
      })
    },
  },
  beforeDestroy() {
    this.markInstance.unmark()
  },
  mounted() {
    this.markInstance = new Mark(this.$el)
    this.markText()
  },
  methods: {
    markText() {
      this.markInstance.unmark({
        done: () => {
          this.markInstance.mark(this.text)
        },
      })
    },
  },
  render() {
    return this.$scopedSlots.default()
  },
}
</script>
